<section class="w-full min-h-screen flex flex-col items-center justify-start mt-26 mb-10">
     <h1 class="font-secondary text-center font-bold text-secondary-800 text-8xl md:text-12xl lg:text-18xl">
       Dlaczego warto <br> <span class="text-primary-600">z nami?</span>
    </h1>
  <div
    class="w-full md:w-[90%] max-w-[1500px] h-auto p-5 md:p-12 flex flex-col items-center justify-center">
    <div
      class="grid gap-6
           grid-cols-1 sm:grid-cols-2 lg:grid-cols-3
           auto-rows-[minmax(180px,auto)] w-full max-w-[1500px]">
      <div
        class="relative group rounded-xl sm:col-span-2 lg:row-span-1 h-[220px] lg:h-[500px] flex items-center justify-center overflow-hidden shadow-2xl">
        <img src="assets/auctions/images/passing-keys.webp" alt="passing-keys"
             class="w-full h-full object-cover group-hover:scale-125 transition-all duration-500 transform">
        <div
          class="card-content">
          <span class="card-title">
            Bez wysokiej <br> wpłaty własnej
          </span>
          <span class="card-desc">
          auto w leasing już od pierwszej raty
        </span>
        </div>
      </div>
      <div
        class="relative group rounded-xl
             lg:col-span-1 lg:row-span-1
             h-[500px] flex items-center justify-center overflow-hidden shadow-2xl">
        <img src="assets/auctions/images/simple-formalities.webp" alt="simple-formalities"
             class="w-full h-full object-cover group-hover:scale-125 transition-all duration-500">
        <div
          class="card-content ring-2">
          <span class="card-title">
            Minimum formalności
          </span>
          <span class="card-desc">
            uproszczona ścieżka dla JDG i MŚP
        </span>
        </div>
      </div>
      <div
        class="relative group rounded-xl
             h-[500px] lg:h-[450px] flex items-center justify-center overflow-hidden shadow-2xl">
        <img src="assets/auctions/images/availability.webp" alt="availability" class="w-full h-full object-cover group-hover:scale-125 transition-all duration-500">
        <div
          class="card-content">
          <span class="card-title">
            Dostępność
          </span>
          <span class="card-desc">
            auta przygotowane do odbioru
        </span>
        </div>
      </div>
      <div
        class="relative group rounded-xl
             h-[450px] flex items-center justify-center overflow-hidden shadow-2xl">
        <img src="assets/auctions/images/transparency.webp" alt="transparency" class="w-full h-full object-cover group-hover:scale-125 transition-all duration-500">
        <div
          class="card-content">
          <span class="card-title">
            Transparentność
          </span>
          <span class="card-desc">
            rata all-in, bez ukrytych opłat
        </span>
        </div>
      </div>
      <div
        class="relative group rounded-xl
             h-[450px] flex items-center justify-center overflow-hidden shadow-2xl">
        <img src="assets/parking/images/amina-atar-Mqc-m8kgxkg-unsplash-min.jpg" alt="elastic-terms" class="w-full h-full object-cover group-hover:scale-125 transition-all duration-500">
        <div
          class="card-content">
          <span class="card-title">
            Elastyczność
          </span>
          <span class="card-desc">
            dopasowane warianty umów
        </span>
        </div>
      </div>
    </div>
  </div>
</section>
